import { ChangeEvent } from 'react';
import { Box, Select } from '@nimbus-ds/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { FormInput, FormSelect } from '../common';

interface Province {
  code: string;
  name: string;
}

interface AddressInfoSectionProps {
  zipCode: string;
  address: string;
  state: string;
  city: string;
  country: string;
  provinces: Province[] | null;
  errors: {
    zipCode?: string;
    address?: string;
    state?: string;
    city?: string;
  };
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (e: ChangeEvent<HTMLSelectElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isLoadingProvinces: boolean;
}

export function AddressInfoSection({
  zipCode,
  address,
  state,
  city,
  country,
  provinces,
  errors,
  handleChange,
  handleChangeSelect,
  handleBlur,
  isLoadingProvinces,
}: Readonly<AddressInfoSectionProps>) {
  const t = useTranslationConfigurations(
    'domains.checkout.registrationInfo.addressInfo',
  );

  return (
    <>
      <Box display="grid" gridTemplateColumns="1fr 3fr" gap="4">
        <FormInput
          label={t('zipCode')}
          name="zipCode"
          value={zipCode}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.zipCode}
        />
        <FormInput
          label={t('address')}
          name="address"
          value={address}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.address}
        />
      </Box>

      <Box display="grid" gridTemplateColumns="1fr 1fr" gap="4">
        <FormSelect
          label={t('state')}
          id="state"
          name="state"
          value={state}
          onChange={handleChangeSelect}
          error={errors.state}
          isLoading={isLoadingProvinces}
          disabled={!country}
        >
          <Select.Option value="" label={t('statePlaceholder')} />
          {provinces?.map((province) => (
            <Select.Option
              key={province.code}
              value={province.code}
              label={province.name}
            />
          ))}
        </FormSelect>

        <FormInput
          label={t('city')}
          name="city"
          value={city}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.city}
        />
      </Box>
    </>
  );
}
